import React, { useEffect, useState, useContext } from "react";
import ApiService from '../../functions/apiService';
import { Box, Chip, Table, TableBody, TableCell, InputAdornment, TableContainer, IconButton, TableHead, TableRow, Autocomplete, Typography, TextField , CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import { Col, Row } from "react-bootstrap";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import moment from "moment";
import { toast } from "react-toastify";
import { varFormatTime } from "../../utils/helperFunctions";
import AuthContext from "../../context/AuthContext";
import SearchIcon from "@mui/icons-material/Search";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import dayjs from 'dayjs';

export default function VolunteerSignup(props) {
	const { user, permission } = useContext(AuthContext);
	const { isNightShift, mode2, onExpandChange, open, date, shift, allowedVars } = props
	const [empList, setEmpList] = useState([])
	const [posList, setPosList] = useState([])
	const [assignModal, setAssignModal] = useState(false);
	const [posId, setPosId] = useState('')
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);
	const [search, setSearch] = useState('')
	const [deleteModal, setDeleteModal] = useState(false)
	const [isFirstTime, setIsFirsttime] = useState(true);
	const [shiftCode, setShiftCode] = useState('')
	const [posCode, setPosCode] = useState('')
	const [unassignEmp, setUnassignEmp] = useState('')
	const [customModal, setCustomModal] = useState(false)
	const [key, setKey] = useState(1)
	const [key2, setKey2] = useState(1)
	const [startTime, setStartTime] = useState('')
	const [endTime, setEndTime] = useState('')
	const [assignEmp, setAssignEmp] = useState('')
	// const [shift, setShift] = useState()
	const [posList2, setPosList2] = useState([]);
	const [modalShiftName, setModalShiftName] = useState();
	const [loading , setLoading] = useState(false);

	const modalClose = () => { setAssignModal(false); setEmpList(''); setSearch('') };
	const modalShow = () => setAssignModal(true);

	const columns = (shiftCode, shift) => {
		let col = [
			{
				field: 'Position_Name',
				headerName: 'Name',
				flex: 1,
				maxWidth : 200,
				minWidth: 160,
				renderCell: (params) => {
					return (
						<Box>
							{params.value}
						</Box>
					);
				}
			},
			{
				field: 'title',
				headerName: 'Name',
				flex: 1,
				minWidth : 340,
				maxWidth: 400,
				renderCell: (params) => (
					<div className={params?.row?.Position_Filled.length > 1 && "shift-arr"} style={{width:'100%'}}>
						{params.row.Position_Filled.length > 0
							? params.row.Position_Filled.map((emp, index) => (
								<Row style={{ alignItems: 'center', marginTop: '5px' }} className="g-0">
									<Col md={8} className="p-0" style={{ whiteSpace: 'normal' }}>{emp.Employee_Rank} {emp.Employee_Name} ({varFormatTime(timeFormat(emp?.Start_Time), user?.Time_Format)} - {varFormatTime(timeFormat(emp?.End_Time), user?.Time_Format)})</Col>
									<Col md={2} className="p-0">
										{permission.includes('Emp_Auth') &&
											<img
												src="/images/revert.png"
												onClick={() => {
													setDeleteModal(true)
													setUnassignEmp(params?.row)
												}}
												width={20}
												height={20}
												style={{ cursor: 'pointer', marginLeft: '10px' }}
											/>}
									</Col>
								</Row>
							))
							:
							<div style={{  textAlign: 'left' }}>Open Position</div>
						}
					</div>
				)
			},
			{
				field: 'action',
				headerName: 'Action',
				flex: 1,
				renderCell: (params) =>
					(permission.includes('Emp_Auth')) && (params?.row?.Position_Filled.length == 0 || params?.row?.Position_Filled?.find(type => type?.Shift_Type === 'CUSTOM')) ? (
						<div className="w-100 d-flex justify-content-start">
							<img
								src="/images/overtime.png"
								width={28}
								height={28}
								style={{ cursor: 'pointer', alignSelf: 'center' }}
								onClick={() => {
									setPosId(params?.row?.Position_Assignment_Id);
									setShiftCode(shiftCode);
									setPosCode(params?.row?.Position_Code);
									setModalShiftName(shift)
									getEmployeeList(shiftCode, params?.row?.Position_Code, params?.row?.Position_Assignment_Id);
									modalShow();
								}}
							/>
						</div>
					) 
					: ''
			}
		]
		return col
	}

	const getPositionList = () => {
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD')
		}
		ApiService.get('/volunteer-list-positions', body)
			.then((data) => {
				var temp = []
				shift.map((a) => {
					if (mode2 == '24') {
						data?.data?.result.map((b)=>{
							if(b.Positions[a?.Shift] !== undefined){
							temp.push({
								data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode
							})}
							 })
					} 
					else if ( a?.Options === 'NIGHT' && mode2 == 'night') {
							data?.data?.result.map((b)=>{
								if(b.Positions[a?.Shift] !== undefined){
							temp.push({
								data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode
							})}
							 })
					}
					else {
						if (a?.Options === 'DAY' && mode2 == 'day') {
							 data?.data?.result.map((b)=>{
								if(b.Positions[a?.Shift] !== undefined){
							temp.push({
								data: b.Positions[a?.Shift], shift: a?.Shift, posName: b?.Assignment_Name, shiftCode: a?.ShiftCode
							})}
							 })
						}
					}
				})
				setPosList2(temp)
			})
			.catch(() => {
				console.error('err')
			})
	}

	const getShiftList = () => {
		ApiService.get('/shiftTypes')
			.then((data) => {
				setShift(data?.data?.data)
				setLoading(false);
			})
			.catch((err) => {
				console.error('error')
			})
	}

	const getEmployeeList = (shift_code, pos_code, pos_id) => {
		setLoading(true);
		let tempShiftCode = shift_code ? shift_code : shiftCode
		let tempPosCode = pos_code ? pos_code : posCode
		let tempPosId = pos_id ? pos_id : posId
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": tempShiftCode,
			"Position_Code": tempPosCode,
			"Position_Assignment_Id": tempPosId,
			"search": search
		}
		ApiService.post('/volunteer-hitlist-employees', body)
			.then((data) => {
				setEmpList(data?.employees)
				setLoading(false);
			})
			.catch(() => {
				console.error('error')
				setLoading(false);
			})
	}

	const assignPosition = (row, type = 'fulltime') => {
		var body = {}
		if (type == 'custom') {
			if (startTime == '' || endTime == '') {
				toast.error('Please fill start time and end time')
				return
			}
			body = {
				"Shift_Date": assignEmp?.Shift_Date,
				"Shift_Code": assignEmp?.Shift_Code,
				"Start_Time": startTime,
				"End_Time": endTime,
				"Emp_Code": assignEmp?.Emp_Code,
				"Position_Assignment_Id": posId,
				"isFullTime": false
			}
		}
		else {
			body = {
				"Shift_Date": row?.Shift_Date,
				"Shift_Code": row?.Shift_Code,
				"Start_Time": row?.Start_Time,
				"End_Time": row?.End_Time,
				"Emp_Code": row?.Emp_Code,
				"Position_Assignment_Id": posId,
				"isFullTime": row?.Value == 'FULLTIME' ? true : false
			}
		}
		ApiService.post('/volunteer-assign-position', body)
			.then((data) => {
				toast.success(data?.message)
				modalClose()
				setCustomModal(false)
				setStartTime('')
				setEndTime('')
				getPositionList()
			})
			.catch((err) => {
				toast.error(err?.data?.message)
			})
	}

	const unAssignPosition = () => {
		const body = {
			"Shift_Date": date ? date : moment().format('YYYY-MM-DD'),
			"Shift_Code": unassignEmp?.Position_Filled[0]?.Shift_Code,
			"Start_Time": unassignEmp?.Position_Filled[0]?.Start_Time,
			"End_Time": unassignEmp?.Position_Filled[0]?.End_Time,
			"Emp_Code": unassignEmp?.Position_Filled[0]?.Employee_ID,
			"Position_Assignment_Id": unassignEmp?.Position_Assignment_Id
		}
		ApiService.post('/volunteer-unassign-position', body)
			.then((data) => {
				getPositionList()
				toast.success(data?.message)
				setDeleteModal(false)
			})
			.catch((err) => {
				toast.error('Error')
				setDeleteModal(false)
			})
	}

	const selectShift = (type, time) => {
		// let checkTime = moment(time).format('HH:mm:ss')
		// if (shiftCode == 2) {
		// 	if (checkTime < '08:00:00' || checkTime > '18:00:00') {
		// 		toast.error('Please select time between 08:00:00 and 18:00:00')
		// 		setKey(val => val + 1)
		// 		return
		// 	}
		// }
		// else if (shiftCode == 3) {
		// 	if (checkTime < '18:00:00' && checkTime > '08:00:00') {
		// 		toast.error('Please select time between 18:00:00 and 08:00:00')
		// 		setKey2(val => val + 1)
		// 		return
		// 	}
		// }
		if (type == 'start_time') {
			setStartTime(moment(time).format('HH:mm:ss'))
		}
		else {
			setEndTime(moment(time).format('HH:mm:ss'))
		}
	}

	useEffect(() => {
		setIsFirsttime(false)
		// getShiftList()
	}, [])

	useEffect(() => {
		if (shift && shift.length > 0) {
			getPositionList()
		}
	}, [ shift , mode2])

	useEffect(() => {
		if (!isFirstTime && (search.length >= 3 || search == '')) {
			setTimeout(() => {
				getEmployeeList();
			}, 500);
		}
	}, [search])

	return (
		<>
			{posList2 &&
				<div style={{
					marginTop:'16px',
					display: 'flex',
					justifyContent: 'left',
					alignItems: 'end',
					paddingLeft: '8px',
					fontSize: '18px',
					fontWeight: 600,
				}}>
					{allowedVars?.V3_VERBIAGE_VOLUNTEER ? "Per-diem Position Assignment" : "Volunteer Position Assignment"}
				</div>
			}

			{/* {allowedVars && Object.keys(allowedVars).includes('V3_DYNAMIC_SHIFTS_VOLUNTEER') ?
			<Row className="w-100">
				{(!isNightShift || mode2 == '24') &&
				<>
					<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.['2']?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name + " " + "(Shift 2)"}
									columns={columns(2)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>

					<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.['3']?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name + " " + "(Shift 3)"}
									columns={columns(2)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>
					</>
				}
				{(isNightShift || mode2 == '24') &&
				<>
					<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.['1']?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name + " " + "(Shift 1)"}
									columns={columns(3)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>

									<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.['4']?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name + " " + "(Shift 4)"}
									columns={columns(3)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>
					</>
				}
			</Row>
			:
			<Row className="w-100">
				{(!isNightShift || mode2 == '24') &&
					<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.Day?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name}
									columns={columns(2)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>
				}
				{(isNightShift || mode2 == '24') &&
					<Col md={mode2 == '24' ? 6 : 9} id="col-width">
						{posList?.result && posList.result.map((result, outerIndex) => {
							const processedRows = result?.Positions?.Night?.map((row, index) => ({
								...row,
								id: `${outerIndex}-${index}`,
							}));
							return (
								<CollapseComponent
									key={outerIndex}
									rows={processedRows}
									name={result?.Assignment_Name}
									columns={columns(3)}
									checkboxSelection={false}
									open={open}
									onExpandChange={onExpandChange}
									showHeader={false}
								/>
							);
						})}
					</Col>
				}
			</Row>
		} */}

			<Row className="w-100 g-1">
				{posList2 && posList2.map((result, outerIndex) => {
					return (
						<Col md={6}>
							<CollapseComponent
								key={outerIndex}
								rows={result?.data}
								name={
									result?.posName +
									(
										result?.shift === '1' || result?.shift === '2' || result?.shift === '3' || result?.shift === '4' || result?.shift === '5'
											? `(Shift-${result?.shift})`
											: `(${result?.shift})`
									)
								}
								columns={columns(result?.shiftCode, result?.shift)}
								checkboxSelection={false}
								open={open}
								onExpandChange={onExpandChange}
								showHeader={false}
							/>
						</Col>
					);
				})}
			</Row>

			<Modal size="lg" show={assignModal} onHide={modalClose}>
				<Modal.Body className='p-4'>
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Typography id="modal-modal-title" sx={{ fontSize: '21px', fontWeight: '700' }}>
							Available Personnel For Shift - {modalShiftName}
						</Typography>
						<img src="/images/close-icon.svg" style={{ cursor: 'pointer' }} onClick={modalClose} />
					</div>

					<Box id="modal-modal-description" sx={{ mt: 2 }}>
						<TextField
							variant="outlined"
							placeholder="Search by Name"
							className="mt-0 w-100"
							color='secondary'
							onChange={(e) => setSearch(e.target.value)}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton>
											<SearchIcon />
										</IconButton>
									</InputAdornment>
								),
								sx: {
									height: '48px',
									fontSize: '14px'
								},
							}}
						/>

						{loading &&
							<div className='my-5' style={{display:'flex' , justifyContent:'center'}}>
									<CircularProgress />
							</div>
						}

						{!loading &&
							<div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
								<TableContainer component={Paper} sx={{
									boxShadow: 'none !important',
									border: '1px solid #EAECF0',
									mt: 2
								}}>

									<Table aria-label="customized table">
										<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
											<TableRow>
												<TableCell>Name</TableCell>
												<TableCell>Availability</TableCell>
												<TableCell>Hours</TableCell>
												<TableCell>Timestamp</TableCell>
												<TableCell>Action</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{empList.length > 0 ? empList.map((row) => (
												<TableRow key={row?.fullName} sx={{
													height: '22px',
													'& .MuiTableCell-root': {
														border: 'none'
													},
													'&:nth-of-type(even)': {
														backgroundColor: 'rgba(204, 204, 204, 0.2)',
													},
												}}>

													<TableCell component="th" scope="row">
														{row?.fullName}
													</TableCell>

													<TableCell component="th" scope="row">
														{/* {moment(row?.Shift_Date).format('dddd')}  */}
														{/* {row?.Value != 'FULLTIME' ? 'on ' + row?.Value.replace(/(^\s*,)|(,\s*$)/g, '') : ''} */}
														{row?.Value == 'FULLTIME' ? 'Fulltime' : varFormatTime(timeFormat(row?.Start_Time), user?.Time_Format) + (' - ') + varFormatTime(timeFormat(row?.End_Time), user?.Time_Format)}
													</TableCell>

													{/* <TableCell component="th" scope="row">
														{row?.Seniority}
													</TableCell> */}

													<TableCell component="th" scope="row">
														{row?.Hours}
													</TableCell>

													<TableCell component="th" scope="row">
														{moment(row?.LogTime).format('MM/DD/YYYY, HH:mm')}
													</TableCell>

													<TableCell component="th" scope="row" align="right">
														<Row>
															<Col md={6}>
																<Chip sx={{
																	height: 'auto',
																	color: 'red',
																	'& .MuiChip-label': {
																		display: 'block',
																		whiteSpace: 'normal',
																	},
																}}
																	style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer'}}
																	label='Assign'
																	color="red"
																	onClick={() => assignPosition(row)}
																/>
															</Col>

															<Col md={6}>
																<Chip sx={{
																	height: 'auto',
																	color: 'red',
																	'& .MuiChip-label': {
																		display: 'block',
																		whiteSpace: 'normal',
																	},
																}}
																	style={{ textAlign: 'center', padding: '6px 0px', width: '100%', cursor: 'pointer'}}
																	label='Custom'
																	color="red"
																	onClick={() => {
																		setAssignEmp(row)
																		setCustomModal(true)
																	}}
																/>
															</Col>
														</Row>
													</TableCell>

												</TableRow>
											))
												:
												<TableRow>
													<TableCell colSpan={6} style={{ textAlign: 'center' }}>
														No results found
													</TableCell>
												</TableRow>
											}
										</TableBody>
									</Table>
								</TableContainer>
							</div>
						}

					</Box>
				</Modal.Body>
			</Modal>

			<Modal show={deleteModal} onHide={() => { setDeleteModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Un-Assign Employee</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ color: '#555555' }}>
						Are you sure to Unassign this Employee from this position?
					</div>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => { setDeleteModal(false) }}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={unAssignPosition}>
								Un-Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>

			<Modal show={customModal} onHide={() => setCustomModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Custom Time</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Row>
						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									className="m-0"
									key={key}
									onAccept={(newValue) => selectShift('start_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>

						<Col md={6}>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<TimePicker
									key={key2}
									className="m-0"
									onAccept={(newValue) => selectShift('end_time', newValue)}
									sx={{
										"& .MuiOutlinedInput-input": { color: 'black' },
										width: "100%",
										"& .MuiInputBase-root": {
											height: '48px',
											fontSize: '14px'
										},
									}}
								/>
							</LocalizationProvider>
						</Col>
					</Row>
					<Row>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setCustomModal(false)}>
								Cancel
							</ButtonTheme>
						</Col>
						<Col md='auto'>
							<ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => assignPosition('', 'custom')}>
								Assign
							</ButtonTheme>
						</Col>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}




{/* <Modal show={assignModal} onHide={modalClose}>
<Modal.Body>
<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
<Typography id="modal-modal-title" sx={{ fontSize: '18px', fontWeight: '700' }}>
Assign Employee
</Typography>
<img src='/images/close-icon.svg' style={{ cursor: 'pointer' }}
onClick={() => {
modalClose();
}}
/>
</div>
<label style={{ fontSize: '14px', marginBottom: '10px', paddingLeft: '4px' }}>Open Positions</label>

<Autocomplete
options={empList}
getOptionLabel={(option) => option.fullName}
// value={duration ? durationOptions.find(opt => opt.value === duration) || null : null}
onChange={(_, newValue) => setAssignEmp(newValue)}
renderInput={(params) => (
<TextField
{...params}
variant="outlined"
size="small"
placeholder="Select Employee"
sx={{
"& .MuiInputBase-root": {
height: "48px",
fontSize: "14px"
}
}}
/>
)}
/>

<ButtonTheme type='submit' variant="filled" color='primary' className='px-5 mt-4'
onClick={assignPosition}
>
Save
</ButtonTheme>
</Modal.Body>
</Modal> */}